import { BsWhatsapp } from 'react-icons/bs';
import styles from './ButtonWhatsapp.module.css'


export default function ButtonWhatsapp() {
    return (
        <div>
            <a href="https://wa.me/+541161361408?text=¡Hola!%20Quisiera%20más%20información%20sobre%20tus%20servicios%20de%20desarrollo%20web%20y%20aplicaciones."  className={styles.whatsapp} target="_blank">


<i className={styles.icon_whatsapp}><BsWhatsapp/></i></a>
	</div>
    )
}